import React, {Component} from 'react';
import PropTypes from 'prop-types';
import fetch from '../../support/fetch';
import { Alert, Card, Grid } from 'tabler-react';
import Loading from '../../Components/Loading';
import SelectedPlan from '../../Components/SelectedPlan';

import './index.sass';


const propTypes = {
    subscriberType: PropTypes.oneOf(['minor', 'adult']).isRequired,
    couponCode: PropTypes.string
};

class Plans extends Component {

    state = {
        plans: [],
        loading: true,
        userHasCreditCard: false,
        plansBusy: false,
        creditCardBusy: false,
        selectedPlan: null,
        modalIsOpened: false
    };

    initialize = () => {
        this.fetchCreditCard(() => {
            this.fetchPlans();
            this.busy();

            // inform to parent component that this
            // component is working on load the component data...
            this.props.loading(true);

            this.setState({
                loading: true,
                plans: []
            });
        });
    };

    unitTranslate = unit => {
        let translation = '';

        switch (unit) {
            case 'YEAR':
                translation = 'ano';
                break;
            case 'MONTH':
                translation = 'mês';
                break;
            case 'DAY':
                translation = 'dia';
                break;
            default:
                translation = '';
                break;
        }

        return translation;
    };

    fetchCreditCard = (callback) => {
        fetch.obj({
            query: `query CheckIfUserHaveCreditCard {
                creditCard {
                    id
                }
            }`,
        })
        .then(res => {
            this.setState({
                userHasCreditCard: res.data.hasOwnProperty('creditCard') && res.data.creditCard !== null,
                creditCardBusy: false
            }, () => callback());

            this.props.loading(this.isBusy());
        });
    };

    /**
     * Check if component is busy.
     *
     * @returns {boolean}
     */
    isBusy = () => {
        return this.state.plansBusy && this.state.creditCardBusy;
    };

    /**
     * Set component as busy.
     */
    busy = () => {
        this.setState({
            plansBusy: true,
            creditCardBusy: true,
        });
    };

    /**
     * Fetch all plans.
     */
    fetchPlans = () => {
        fetch.obj({
            query: `query FetchAllAvailablePlans($subscriberType: String!, $couponCode: String) {
                availablePlans (subscriberType: $subscriberType, couponCode: $couponCode) {
                    id,
                    name,
                    description,
                    currency,
                    amount,
                    amountFrom,
                    paymentMethod,
                    paymentMethodCode,
                    unit,
                    length,
                    code
                }
            }`,
            variables: {
                subscriberType: this.props.subscriberType,
                couponCode: this.props.couponCode
            }
        })
        .then(res => {
            if (! res.data.hasOwnProperty('availablePlans')) {
                this.setState({
                    loading: false
                });
                return;
            }

            const plans = [];

            res.data.availablePlans.forEach((plan, index) => {
                if(plan.code.match(/LIGHT_.*/) || plan.code.match(/PREMIUM_.*/) || plan.code.match(/VIP_.*/)) {
                    plans.push(plan);
                }
            });
            plans.sort((a, b) => {
                if ( a.code < b.code ){
                    return -1;
                  }
                if ( a.code > b.code ){
                    return 1;
                }
                return 0;
            });

            const plansTemplate = [];
            plans.forEach((plan, index) => {
                plansTemplate.push(this.planTemplate(plan, index));
            });

            this.setState({
                plans: plansTemplate,
                loading: false,
                plansBusy: false
            });

            this.props.loading(this.isBusy());
        });

    };

    selectPlan = plan => {
        this.setState({
            selectedPlan: plan,
            modalIsOpened: true
        });
    };

    planTemplate = (plan, index) => {

        let recommended = false;

        if (plan.unit.toLowerCase().search('year') !== -1 && plan.paymentMethodCode === 'C') {
            recommended = true;
        }

        let btnClass = ['btn btn-select-plan btn-block'];
        btnClass.push(recommended ? 'btn-success color-white' : 'btn-secondary');

        let planClass = ['col-md-4 plan'];

        if (plan.paymentMethodCode === 'C' && !this.state.userHasCreditCard) {
            planClass.push('disabled');
        }

        // console.log(plan.paymentMethodCode, this.state.userHasCreditCard);

        return (
            <div className={planClass.join(' ')} key={index}>
                <div className="card">
                    { recommended && <Card.Status color="green" /> }
                    <div className="card-body text-center">
                        <div className="card-category">
                            {plan.name}<br/>
                            {
                                !recommended &&
                                <React.Fragment>
                                    <br/>
                                </React.Fragment>
                            }
                            {
                                recommended &&
                                <small>recomendado</small>
                            }
                        </div>

                        <div className="display-1 mt-0">{plan.amount.toFixed(2).replace('.', ',')}</div>

                        <div className="billing-cycle">
                            {plan.length === 1 && 'por '}
                            {plan.length > 1 && 'a cada ' + plan.length}
                            {' ' + this.unitTranslate(plan.unit)}
                        </div>

                        <div className="separator">---</div>

                        <p
                            className="m-3"
                            style={{height: '90px'}}
                        >{plan.description}</p>

                        <div className="text-center mt-6">
                            {
                                (plan.paymentMethodCode === 'B' || this.state.userHasCreditCard) &&
                                <a
                                    href="#"
                                    className={btnClass.join(' ')}
                                    onClick={e => this.selectPlan(plan)}>Selecionar este Plano</a>
                            }

                            {
                                plan.paymentMethodCode === 'C' && !this.state.userHasCreditCard &&
                                <div>
                                    <Alert type="warning">
                                        <small>Este plano requer cartão de crédito.</small>
                                    </Alert>

                                    <a href="/credit-card/new" className="small">adicionar cartão de crédito</a>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    waitingContent = () => {
        return (
            <Loading />
        );
    };

    componentDidMount = () => {
        this.initialize();
    };

    componentDidUpdate = (prevProps, prevState) => {
        if((this.props.couponCode !== prevProps.couponCode) && !this.isBusy()) {
            this.initialize();
            console.log('Aguarde, atualizando a lista de planos...')
        }
    };

    onCloseModalHandler = open => {
        this.setState({modalIsOpened: open});
        // console.log('fechar modal invocado...', open);
    };

    render() {
        const invalidCouponCode = (
            <React.Fragment>
                Nenhum plano encontrado para o cupom:<br/>
                <strong>"{this.props.couponCode}"</strong>
                <br/>
                <a href="?" className="btn btn-pill btn-sm btn-outline-primary mt-4" >Limpar filtro</a>
            </React.Fragment>
        );

        return (
            <React.Fragment>
                {
                    !this.state.loading &&
                    this.state.plans.length === 0 &&
                    <p className="text-center mt-7">
                        {
                            this.props.couponCode
                            ? invalidCouponCode
                            : 'Nenhum plano encontrado'
                        }
                    </p>
                }

                <div className="row plans">
                    {!this.state.loading && this.state.plans}
                    {this.state.loading && this.waitingContent()}
                </div>

                <SelectedPlan
                    open={this.state.modalIsOpened}
                    onClose={this.onCloseModalHandler}
                    plan={this.state.selectedPlan}
                    couponCode={this.props.couponCode}
                />
            </React.Fragment>
        );
    }
}

Plans.propTypes = propTypes;

export default Plans;